module.exports = __webpack_public_path__ + "static/cheer-862648bc0f692042e65eaff66e454094.mp3";